import { NamedDefinitionPage } from './NamedDefinitionPage';

export function VendorSubGroupsPage() {
  return (
    <NamedDefinitionPage
      apiBase="/api/vendorsubgroups"
      listRoute="/vendor-sub-groups"
      title="Distribütör Ek Grubu Yönetimi"
      subtitle="Distribütör ek grubu kayıtlarını filtreleyin, sıralayın ve yönetin."
      codeLabel="Ek Grup Kodu"
      descriptionLabel="Açıklama"
      newLabel="Yeni Distribütör Ek Grubu"
    />
  );
}
